/* eslint-disable @typescript-eslint/no-unused-vars */
"use client";

import * as X from "@/ui";

import { Swiper, SwiperSlide } from "swiper/react";
import type { Swiper as SwiperInstance } from "swiper";

import "swiper/css";
import { useRetailerHomePage } from "@/providers/strapi/content/types/singleTypes/retailer-home-page";
import ReactMarkdown from "react-markdown";
import { StrapiImage } from "@/providers/strapi";


// const data = {
//   customers: [
//     {
//       name: "Excellence Rhum",
//       logo: LogoRhum,
//       url: {
//         en: "https://www.excellencerhum.com/en/",
//         fr: "https://www.excellencerhum.com/fr",
//       }
//     },
//     {
//       name: "Gong Galaxy",
//       logo: LogoGong,
//       url: {
//         en: "https://www.gong-galaxy.com/en",
//         fr: "https://www.gong-galaxy.com/",
//       },
//     },
//     {
//       name: "Seagale",
//       logo: LogoSeagale,
//       url: {
//         en: "https://seagale.fr/en/",
//         fr: "https://seagale.fr/fr/",
//       },
//     },
//   ],
// };


export function CustomersSection(_props: X.PageProps) {
  // const tr = X.useTranslator();

  const retailerCustomerCard = useRetailerHomePage("retailerCustomerCard");

  return (
    <section className={X.clsx("relative mt-20 xl:mt-30 xl:-mb-10")}>
      {/*
      <h2 className="text-[30px] xl:text-[36px] [&_strong]:font-medium text-center xl:max-w-content mx-mobile-margin xl:mx-auto mb-1 xl:mb-5 leading-tight">
        {tr({
          en: <>Trusted by <strong>forward-thinking brands</strong></>,
          fr: <>D’autres enseignes <strong>nous font déjà confiance  </strong></>,
        })}
      </h2>
      */}
      <ReactMarkdown components={{
        p: ({ ...props }) => <h2 {...props} className="text-[30px] xl:text-[36px] [&_strong]:font-medium text-center xl:max-w-content mx-mobile-margin xl:mx-auto mb-1 xl:mb-5 leading-tight" />
      }}>
        {retailerCustomerCard.title}
      </ReactMarkdown>
      <div className={X.mobileOnly()}>
        <SliderMobile />
      </div>

      <div className={X.clsx(X.desktopOnly("block"), "max-w-content mx-auto")}>
        <SliderDesktop />
      </div>
    </section>
  );
}


function SliderMobile() {
  const ref = X.useRef<SwiperInstance | null>(null);
  const [isFirst, setIsFirst] = X.useState(false);
  const [isLast, setIsLast] = X.useState(false);

  X.useEffect([ref.current], () => {
    if (!ref.current) {
      return;
    }

    const s = ref.current;
    const update = (swiper: SwiperInstance) => {
      setIsFirst(swiper.isBeginning);
      setIsLast(swiper.activeIndex === swiper.slides.length - 1);
    };

    s.on("slideChange", update);
    update(ref.current);

    return () => s.off("slideChange", update);
  });

  const retailerCustomerCard = useRetailerHomePage("retailerCustomerCard");

  return (
    <div className="relative">
      <Swiper
        spaceBetween={16}
        slidesPerView={1.18}
        className="xl:h-full"
        slidesOffsetBefore={32}
        slidesOffsetAfter={32}
        onSwiper={swiper => {
          ref.current = swiper;
        }}
      >
        {/* {data.customers.map((customer, i) => (
          <SwiperSlide key={i}>
            <Slide customer={customer} />
          </SwiperSlide>
        ))} */}
        {retailerCustomerCard.slides.map((customer, i) => (
          <SwiperSlide key={i}>
            <Slide customer={customer} />
          </SwiperSlide>
        ))}
      </Swiper>

      <NavButton
        small
        direction="left"
        canPress={!isFirst}
        onPress={() => ref.current?.slidePrev()}
        className="left-mobile-margin top-1/2 -translate-y-1/2"
      />
      <NavButton
        small
        direction="right"
        canPress={!isLast}
        onPress={() => ref.current?.slideNext()}
        className="right-mobile-margin top-1/2 -translate-y-1/2"
      />
    </div>
  );
}


function SliderDesktop() {
  const ref = X.useRef<SwiperInstance | null>(null);

  /* the only reliable way to see if clickable or not; `isBeginning` and `isEnd`
   * doe not work properly */
  const swiper = ref.current;
  const activeIndex = swiper?.activeIndex ?? 0;
  const lastIndex = (swiper?.slides.length ?? 1) - 1;
  const isFirst = activeIndex === 0;
  const isLast = activeIndex === lastIndex;
  const retailerCustomerCard = useRetailerHomePage("retailerCustomerCard");
  return (
    <div className="relative px-4 xl:px-8">
      <div className="relative max-w-content mx-auto overflow-hidden">
        <Swiper
          spaceBetween={32}
          slidesPerView={3}
          className="w-full"
          onSwiper={swiper => {
            ref.current = swiper;
          }}
        >
          {retailerCustomerCard.slides.map((customer, i) => (
            <SwiperSlide key={i}>
              <Slide customer={customer} />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>

      <NavButton
        direction="left"
        canPress={!isFirst}
        onPress={() => swiper?.slidePrev()}
        className="-left-6 top-1/2 -translate-y-1/2"
      />
      <NavButton
        direction="right"
        canPress={!isLast}
        onPress={() => swiper?.slideNext()}
        className="-right-6 top-1/2 -translate-y-1/2"
      />
    </div>
  );
}


function NavButton(props: {
  className?: string;
  direction: "left" | "right";
  canPress: boolean;
  onPress: () => void;
  small?: boolean;
}) {
  const iconSize = props.small ? 16 : 24;
  const buttonSize = props.small ? "h-6 w-6" : "h-10 w-10";

  return (
    <button
      onClick={props.onPress}
      disabled={!props.canPress}
      className={X.clsx(
        "absolute z-10 flex items-center justify-center",
        "rounded-full shadow-sm transition-all",
        buttonSize,
        props.className,
        props.canPress
          ? "bg-white hover:bg-gray-50 text-black cursor-pointer"
          : "bg-gray-100 text-gray-400"
      )}
    >
      {props.direction === "left" ? (
        <X.Icon.ChevronLeft size={iconSize} />
      ) : (
        <X.Icon.ChevronRight size={iconSize} />
      )}
    </button>
  );
}


function Slide(props: {
  customer: {
    name: string;
    logo: StrapiImage;
    url: string;
  };
}) {
  // const tr = X.useTranslator();

  return (
    <X.ExternalLink
      // href={tr(props.customer.url)}
      href={props.customer.url}
      className={X.clsx(
        "p-4 xl:px-10 xl:py-8 flex flex-col justify-center items-center h-[200px] group",
      )}>
      <X.Image
        src={props.customer.logo.url}
        width={props.customer.logo.size}
        height={props.customer.logo.size}
        alt={props.customer.name}
        unoptimized
        className="h-auto w-[200px] group-hover:scale-110 duration-300 transform-gpu"
      />
    </X.ExternalLink>
  );
}
